/**
 * NOLAS 2026 (Mikaël FOURNY).
 * src/i18n/fr.inscription.ts
 *
 * Clés du parcours d'inscription : consentements réellement facultatifs,
 * champ établissement, année de naissance, protection des personnes mineures.
 *
 * Pourquoi un sous-catalogue plutôt que `fr.ts` :
 *   `fr.ts` est LE point de contact de tous les lots de travail. Il avait été
 *   gelé au lot précédent, et chacun devait SIGNALER ses clés au lieu de les
 *   écrire : 47 clés à reporter à la main après la fusion. Cette fois chaque
 *   lot a son fichier, il y écrit librement, et `fr.ts` ne bouge plus.
 *
 * ⚠ Jamais le nom d'un type d'événement ni celui d'une activité en dur :
 *   jetons {eventType*} / {lexWorkshop*}, sans quoi le garde-fou d'identité
 *   passe au rouge et une autre instance afficherait un vocabulaire qui n'est
 *   pas le sien.
 *
 * Mikael - chef de projet - 2026-09-09
 */
export const messagesInscriptionFr: Record<string, string> = {
  // ── Année de naissance ────────────────────────────────────────────────
  // Le formulaire proposait un profil scolaire sans jamais demander l'âge :
  // une personne mineure inscrite seule était enregistrée comme majeure et
  // perdait toutes les protections prévues pour elle.
  'inscription.birthYear.label': 'Année de naissance',
  'inscription.birthYear.help':
    'Quatre chiffres. Elle sert uniquement à appliquer les protections prévues pour les personnes mineures.',
  // ⚠ Ce que ce champ commande, et ce qu'il ne commande pas : il déclenche
  // l'anonymisation accélérée, l'interdiction du suivi comportemental et
  // l'affichage du prénom seul. Il n'interdit aucun dépôt de document :
  // l'organisation a signé une convention avec les familles.
  'inscription.birthYear.invalid':
    'Indiquez votre année de naissance en quatre chiffres.',
  'inscription.birthYear.under13':
    'Avant 13 ans, l’inscription se fait avec un adulte responsable : demandez-lui de vous inscrire depuis son propre compte.',

  // ── Consentement au suivi de présence ─────────────────────────────────
  // La case annonçait « facultative » et bloquait pourtant l'inscription. Elle
  // est désormais réellement facultative, elle commande réellement le suivi,
  // et elle se retire depuis l'espace personnel.
  'inscription.consent.tracking.withdrawHint':
    'Vous pourrez revenir sur ce choix à tout moment depuis votre profil.',

  // ── Cartes de choix de profil ─────────────────────────────────────────
  // « Animateur {lexWorkshopDefPlural} » donnait « Animateur les ateliers »,
  // qui n'est pas du français. La forme sans article gère l'élision quel que
  // soit le mot configuré pour l'instance : « d’ateliers », « d’activités »,
  // « de démonstrations ».
  'role.card.workshopHost.title.v2': 'Animateur {lexWorkshopOfPluralBare}',
};
